<div fxLayout="row">
    <div fxLayout="row" fxLayoutAlign="start center" fxFlex.gt-sm="50" class="theme">
        <div fxLayout="column" fxFlexOffset.gt-md="30" fxFlex.gt-sm="60" fxFlex.lt-lg="100">
            <h1>The science we need for the ocean we want</h1>
            <div>
                <p>
                    MARIS, the only global marine radioactivity information system, provides open access to over 800,000 measurements from 1957 to the present day. MARIS plays a vital role allowing us to
                    monitor pollutants in the marine environment resulting from human activities and to apply radiotracer techniques for researching ocean processes.
                </p>
            </div>
        </div>
    </div>
    <div fxLayout="column" fxFlex.gt-sm="50" fxHide.lt-md class="intro-cover"></div>
</div>
<div fxLayoutAlign="center" class="top-offset" fxLayout="row">
    <div fxLayout="row" fxLayout.lt-md="column" fxFlex="70" fxFlex.lt-md="100" fxFlexOffset.lt-md="0">
        <div fxFlex="60" fxFlex.lt-md="100" class="question-section">
            <h3 class="top-offset">Why use MARIS?</h3>
            <div>
                MARIS can be used by anyone to access reliable and traceable information on radioactivity in the marine environment. Scientists use it to investigate levels of radioactivity at
                different locations and times as background research for new projects, for reanalyses and for baseline data against which new data can be evaluated. MARIS is used for radiation dose
                assessments. Marine modellers use it to validate models. Oceanographers use it to quantify climate and ocean change using radiotracers.
            </div>
            <h3 class="top-offset">Why provide data to MARIS?</h3>
            <div>
                Sharing the results of your scientific research via MARIS has many benefits including global availability and a stable and permanent location. The development of a consistent,
                comprehensive and current global database of marine radioactivity data is vital for supporting many aspects of marine science.
            </div>
        </div>
        <div fxFlex="40" fxFlex.lt-md="100" class="form-section">
            <div class="content">
                <h4>Get Involved</h4>
                <span>
                    Would you like to learn more about MARIS? Do you have data that you would like to share with other MARIS users? Get in touch to learn how you can contribute to global marine
                    radioactivity science and research. Complete the contact form below and the MARIS Team at the IAEA Marine Environment Laboratories in Monaco will get back to you soon.
                </span>

                <form [formGroup]="getInvolvedForm" (ngSubmit)="onSubmit()">
                    <div class="form-row">
                        <div class="form-group col">
                            <input type="text" formControlName="nameabc" class="form-control" placeholder="Name*" [ngClass]="{ 'is-invalid': submitted && f.nameabc.errors }" />
                            <div *ngIf="submitted && f.nameabc.errors" class="invalid-feedback">
                                <span *ngIf="f.nameabc.errors.required">Name is required</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col">
                            <input
                                type="text"
                                formControlName="emailbcd"
                                class="form-control"
                                placeholder="Email*"
                                [ngClass]="{
                                    'is-invalid': submitted && f.emailbcd.errors
                                }"
                            />
                            <div *ngIf="submitted && f.emailbcd.errors" class="invalid-feedback">
                                <span *ngIf="f.emailbcd.errors.required">Email is required</span>
                                <span *ngIf="f.emailbcd.errors.pattern">Email must be a valid email address</span>
                            </div>
                        </div>
                        <div class="form-group col">
                            <input type="text" formControlName="confirmEmail" class="form-control" placeholder="Confirmation Email*" [ngClass]="{ 'is-invalid': submitted && f.confirmEmail.errors }" />
                            <div *ngIf="submitted && f.confirmEmail.errors" class="invalid-feedback">
                                <span *ngIf="f.confirmEmail.errors.required">Confirmation Email is required</span>
                                <span *ngIf="f.confirmEmail.errors.mustMatch">Emails must match</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col">
                            <textarea
                                formControlName="otherAreaOfInterest"
                                class="form-control"
                                placeholder="Comment/ Message"
                                [ngClass]="{ 'is-invalid': submitted && f.otherAreaOfInterest.errors }"
                                rows="3"
                            ></textarea>
                            <div *ngIf="submitted && f.otherAreaOfInterest.errors" class="invalid-feedback">
                                <span *ngIf="f.otherAreaOfInterest.errors.required">Comment/ Mesage is required</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <button class="btn btn-light" [disabled]="notChecked">Get in touch</button>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px" class="pt-3">
                        <mat-checkbox color="accent" formControlName="acceptGDPR" id="acceptGDPR" [ngClass]="{ 'is-invalid': submitted && f.acceptGDPR.errors }"></mat-checkbox>
                        <div class="get-involved-text" [ngClass]="{ invalid: submitted && f.acceptGDPR.errors }">
                            I consent that my name and email address will be processed in accordance with the
                            <a href="https://www.iaea.org/about/privacy-policy" target="_blank" rel="noopener noreferrer">IAEA Privacy Policy</a> and will be used for the purpose of providing
                            information on MARIS updates, communicating with me in response to my enquiry and improving IAEA services. I acknowledge that my data will be kept for 5 years. More
                            information can be obtained by emailing <a href="mailto:NAML-MARIS.Contact-Point@iaea.org">NAML-MARIS.Contact-Point@iaea.org</a>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
